// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1SLcF","info":"PatientInfo_info__V9qh4"};